import axios from "@aceso/utils/axios";

const getClusterName = (url) => {
  if (
    url.includes("localhost:3000") ||
    url.includes("healthcare-fe.rcluster.stack8s.com")
  ) {
    return "amia";
  }

  const match = url.match(/healthcare-fe\.(.*?)\.rcluster.stack8s.com/);
  return match ? match[1] : null;
};

export const getClusterAPIEndpoint = () => {
  // // Check if the URL contains localhost:3000 or healthcare-fe.rcluster.stack8s.com
  // let url = typeof window !== "undefined" ? window.location.href : "";

  // // API For development cluster frontend
  // if (
  //   url.includes("localhost:3000") ||
  //   url.includes("healthcare-fe.rcluster.stack8s.com")
  // ) {
  //   return `${process.env.NEXT_PUBLIC_HEALTHCARE_DEV_BASE_URL}`;
  // }

  // // API For productions clusters frontend
  // const match = url.match(/healthcare-fe\.(.*?)\.rcluster.stack8s.com/);
  // let clusterName = match ? match[1] : null;
  // let apiUrl = process.env.NEXT_PUBLIC_HEALTHCARE_PROD_BASE_URL.replace(
  //   "CLUSTER_NAME",
  //   clusterName
  // );

  // return apiUrl;

  return (
    process.env.NEXT_PUBLIC_HEALTHCARE_DEV_BASE_URL ||
    process.env.NEXT_PUBLIC_CLUSTER_API_ENDPOINT ||
    ""
  );
};

export const loadData = async () => {
  try {
    const auth0ClientId = process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID;
    const auth0OrgId = process.env.NEXT_PUBLIC_AUTH0_ORG_ID;

    // Check if values already exist in localStorage
    const existingClientId = localStorage.getItem("auth0_healthcare_clientID");
    const existingOrgId = localStorage.getItem("auth0_orgID");

    // Only set and reload if values are different
    let needsReload = false;

    if (auth0ClientId && auth0ClientId !== existingClientId) {
      localStorage.setItem("auth0_healthcare_clientID", auth0ClientId);
      needsReload = true;
    }

    if (auth0OrgId && auth0OrgId !== existingOrgId) {
      localStorage.setItem("auth0_orgID", auth0OrgId);
      needsReload = true;
    }

    // Only reload if we actually changed something
    if (needsReload) {
      window.location.reload();
    }
  } catch (error) {
    console.error("Error loading data:", error);
  }
};
